<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../../../../../component/common/Image/FontAwesomeView.svelte";
    import {MessageStore} from "../../../../../store/MessageStore";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";
    import {HttpRequestUtil} from "../../../../../lib/Common/Http/HttpRequestUtil";
    import {UserAgentUtil} from "../../../../../lib/Common/UserAgent/UserAgentUtil";
    import {BinaryTable} from "../../../../../lib/Table/BinaryTable";
    import {QrCodeDialogStore} from "../../../../../store/dialog/QrCodeDialogStore";
    import {QrCodeUtil} from "../../../../../lib/Common/QrCode/QrCodeUtil";

    const dispatcher = createEventDispatcher();

    export let binary;
    export let isLargeQrCode = false;

    $: installUrl = (() => {
        if (binary == null) {
            return null;
        }
        const installUrl = createInstallUrl(binary);
        return installUrl;
    })();

    $: qrCodeImageUrl = (() => {
        let size = 100;
        if (isLargeQrCode) {
            size = 300;
        }
        const qrCodeImageUrl = QrCodeUtil.createImageUrl(installUrl, size);
        return qrCodeImageUrl;
    })();

    $: isQRInstallTarget = (() => {
        if (binary.type !== BinaryTable.Type.Application) {
            return false;
        }

        const platformType = binary.platform_type;
        switch (platformType) {
            case BinaryTable.PlatformType.Android:
            case BinaryTable.PlatformType.IOS:
                break;
            default:
                return false;
        }

        return true;
    })();

    $: errorMessage = (() => {
        if (!isQRInstallTarget) {
            return "インストール対象\nではありません";
        }
        if (binary.download_key == null) {
            return "ダウンロードキーが\nありません";
        }
        if (binary.status !== BinaryTable.Status.Success) {
            return "アップロードが\n完了していません";
        }
        if (binary.status === BinaryTable.ConvertStatus.Error) {
            return "バイナリファイルの\n変換に失敗しました";
        }


        return null;
    })();


    let isLoading = false;

    onMount(() => {
    });


    function createInstallUrl(binary) {
        const platformType = binary.platform_type;

        const osType = UserAgentUtil.getOsType();
        const isSmartPhone = UserAgentUtil.isSmartPhone(osType);

        if (platformType === BinaryTable.PlatformType.IOS) {
            // すべて https でないと動かないことに注意


            const downloadKey = binary.download_key;

            const locationOrigin = location.origin;
            const plistUrl = `${locationOrigin}/api/binary/plist/${downloadKey}`;
            const url = `itms-services://?action=download-manifest&url=${plistUrl}`;
            const encodedUrl = url.replace('&', '&amp;');
            return encodedUrl;
        } else {
            // ios以外


            return createDownloadUrl(binary);
        }
    }

    function createDownloadUrl(binary) {
        const downloadKey = binary.download_key;
        let url = `/api/binary/download?download_key=${downloadKey}`;

        const convertedS3Key = binary.converted_s3_key;
        if (convertedS3Key != null) {
            // 変換済のファイルがある場合は変換済のファイルをダウンロードする
            url += `&converted`;
        }

        const locationOrigin = location.origin;
        url = `${locationOrigin}${url}`;

        return url;
    }

    function onClickRefreshSecretKey() {
        const message = `QRコードをリフレッシュしますか？`;
        MessageStore.showConfirmInformationYesNo(message, () => {
            const url = UrlUtil.createApiUrl("binary/refresh_download_key");

            const paramMap = {};
            paramMap['id'] = binary.id;

            isLoading = true;
            HttpRequestUtil.postRequest(url, paramMap, (response) => {
                isLoading = false;
                console.log(response);
                const body = response['body'];


                dispatcher('update');

            });

        });

    }

    function onClick() {
        const showData = new QrCodeDialogStore.ShowData();
        showData.qrCodeValue = installUrl;
        showData.title = `${binary.name} - バイナリQRコード`;
        showData.size = 500;
        QrCodeDialogStore.showData.set(showData);

    }

</script>

<div class="binary-qr-code-view" data-install-url={installUrl}
     class:cancel={binary.status === BinaryTable.Status.Cancel}
     class:empty={binary.status === BinaryTable.Status.Empty}
     class:building={binary.status === BinaryTable.Status.Building}
     class:new={binary.status === BinaryTable.Status.New}
     class:uploading={binary.status === BinaryTable.Status.Uploading}
     class:success={binary.status === BinaryTable.Status.Success}
>
    {#if binary.status === BinaryTable.Status.Empty}
        <div class="message">
            ファイルが<br/>アップロード<br/>されていません。
        </div>
    {:else if binary.status === BinaryTable.Status.Building}
        <div class="icon animation-loading-rotate">
            <FontAwesomeView icon="rotate"/>

        </div>
        <div class="message">
            ビルド中です。
        </div>
    {:else if binary.status === BinaryTable.Status.New}
        <div class="message">
            アップロード待ちです
        </div>
    {:else if binary.status === BinaryTable.Status.Uploading}
        <div class="message">
            アップロード中です
        </div>
    {:else if binary.status === BinaryTable.Status.Success}
        {#if errorMessage == null}
            <div class="qr-code-image-area" on:click={onClick}>
                {#if isLargeQrCode}
                    <img class:large={isLargeQrCode}
                         src={qrCodeImageUrl} alt="QRコード"/>
                {:else}
                    <div class="icon">
                        <FontAwesomeView icon="qrcode"/>
                    </div>

                    <div class="text-area">
                        <span>
                            クリックすると<br/>大きく表示
                        </span>
                    </div>

                {/if}

            </div>
        {:else}
            <div class="message">
                { errorMessage }
            </div>
        {/if}


        {#if isQRInstallTarget}
            <div class="refresh-button-area">
                <div class="refresh-button" on:click={onClickRefreshSecretKey}>
                    <FontAwesomeView icon="rotate"/>
                    再生成
                </div>
            </div>
        {/if}
    {:else if binary.status === BinaryTable.Status.Cancel}
        <div class="message">
            ビルド/アップロードが<br/>キャンセルされました
        </div>
    {/if}

</div>
<style lang="scss">
    .binary-qr-code-view {
        display: inline-block;
        position: relative;
        min-height: 3em;
        //min-width: 8em;

        .message {
            font-size: 0.75em;
            opacity: 0.5;
            white-space: pre;
            text-align: left;
        }

        &.building {
            display: flex;
            flex-direction: column;
            gap: 4px;
            align-items: center;
            width: 90px;

            .icon {
                font-size: 60px;
                width: 90px;
                height: 90px;
                animation-duration: 2s;
                //background-color: #fcc;
            }
        }

        &.success {
            .qr-code-image-area {
                cursor: zoom-in;
                position: relative;

                > img {
                }

                .icon {
                    opacity: 0.1;
                    font-size: 60px;
                }

                .text-area {
                    pointer-events: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;

                    display: flex;
                    align-items: center;
                    justify-items: center;

                    opacity: 0.5;

                    > span {
                        font-size: 0.5em;
                        display: block;
                        width: 100%;
                        text-align: center;
                    }
                }

                &:hover {
                    .text-area {
                        opacity: 1;
                    }
                }

            }


            .refresh-button-area {
                opacity: 0;
                text-align: right;

                font-size: 0.5em;

                .refresh-button {
                    cursor: pointer;

                }
            }

            &:hover {
                .refresh-button-area {
                    opacity: 1;
                }

                .open-button-area {
                    opacity: 1;
                }
            }

        }


    }
</style>